/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StatsGetResponse } from './StatsGetResponse';
import {
    StatsGetResponseFromJSON,
    StatsGetResponseFromJSONTyped,
    StatsGetResponseToJSON,
} from './StatsGetResponse';

/**
 * 
 * @export
 * @interface GetStats200ResponseAllOf
 */
export interface GetStats200ResponseAllOf {
    /**
     * 
     * @type {StatsGetResponse}
     * @memberof GetStats200ResponseAllOf
     */
    result: StatsGetResponse;
}

/**
 * Check if a given object implements the GetStats200ResponseAllOf interface.
 */
export function instanceOfGetStats200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStats200ResponseAllOfFromJSON(json: any): GetStats200ResponseAllOf {
    return GetStats200ResponseAllOfFromJSONTyped(json, false);
}

export function GetStats200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStats200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': StatsGetResponseFromJSON(json['result']),
    };
}

export function GetStats200ResponseAllOfToJSON(value?: GetStats200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': StatsGetResponseToJSON(value.result),
    };
}

